

export const TaskCompleteValidInit = {
  subTasks: false,
  hoursSpent: false,
  assignees: false,
}